var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandidateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13031",
    "data-name": "Group 13031",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12978",
    "data-name": "Path 12978",
    d: "M18,18a6,6,0,1,0-6-6A6,6,0,0,0,18,18Zm4-6a4,4,0,1,1-4-4A4,4,0,0,1,22,12Zm8,16a1.959,1.959,0,0,1-2,2H8a1.959,1.959,0,0,1-2-2c0-2,2-8,12-8S30,26,30,28Zm-2-.008a5.344,5.344,0,0,0-1.664-3.328C25.032,23.36,22.578,22,18,22s-7.032,1.36-8.336,2.664A5.355,5.355,0,0,0,8,27.992Z",
    transform: "translate(-6 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateWhite);
export default __webpack_public_path__ + "static/media/candidate-white.9f061990d2c9b12327d8b21d3e6a1b5c.svg";
export { ForwardRef as ReactComponent };